module.exports = __webpack_public_path__ + "static/01-1ec59f0ea1cec4b7e3ccb3c54f911e98.jpg";